module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-17.2f93ff8f.png";